import {get_nested} from "../../../services/JsonHandler";
import {isNullOrUndefined} from "../../../services/Validator";
import DetailedCourseExampleQuestionText from "../../texts/courses/DetailedCourseExampleQuestionText";
import DetailedCourseExampleAnswerText from "../../texts/courses/DetailedCourseExampleAnswerText";
import DetailedCourseExampleExplanationText from "../../texts/courses/DetailedCourseExampleExplanationText";
import SystemExplanationsDivider from "../../dividers/SystemExplanationsDivider";
import DetailedCourseExampleCardHeader from "./DetailedCourseExampleCardHeader";
import SystemCardHeaderDivider from "../../dividers/SystemCardHeaderDivider";
import SystemKnowledgeExamplePicture from "../../images/SystemKnowledgeExamplePicture";

export default function DetailedCourseLevelAKnowledgeExample({knowledge}) {
    // Used in DetailedCourseScreenContent to display

    // PROPERTIES
    const knowledgeExampleQuestion = get_nested(['exampleQuestion'], knowledge, null)
    const knowledgeExampleAnswer = get_nested(['exampleAnswer'], knowledge, null)
    const knowledgeExampleExplanation = get_nested(['exampleExplanation'], knowledge, null)
    const knowledgePictureUrl = get_nested(['knowledgeExamplePicture', 'filePath'], knowledge, null)
    const knowledgePictureRatio = get_nested(['knowledgeExamplePicture', 'ratio'], knowledge, null)

    // BUILD
    if (isNullOrUndefined(knowledge)
        || isNullOrUndefined(knowledgeExampleQuestion)
        || isNullOrUndefined(knowledgeExampleAnswer)
        || isNullOrUndefined(knowledgeExampleExplanation))
        return null
    return (
        <div className={"bg-backgroundLight5 w-full flex-col shadow-[inset_0px_1px_2px_rgba(82,96,120,1)] rounded-[16px] mt-[20px] pb-[12px]"}>
            {/** HEADER */}
            <DetailedCourseExampleCardHeader headerTitle={`Exercice type corrigé`} />
            <SystemCardHeaderDivider />
            {/** CONTENT */}
            <div className={"w-full flex flex-col px-[12px]"}>
                <DetailedCourseExampleQuestionText exampleQuestion={knowledgeExampleQuestion} />
                <SystemKnowledgeExamplePicture pictureUrl={knowledgePictureUrl}
                                               pictureRatio={knowledgePictureRatio} />
                <DetailedCourseExampleAnswerText exampleAnswer={knowledgeExampleAnswer} />
                <div className={"w-full flex flex-col mt-[16px]"}>
                    {/** ---- DIVIDER */}
                    <SystemExplanationsDivider />
                    {/** ---- BOTTOM PART */}
                    <DetailedCourseExampleExplanationText exampleExplanation={knowledgeExampleExplanation} />
                </div>
            </div>
        </div>
    );
}